import { render, staticRenderFns } from "./GalleryDetailLink.vue?vue&type=template&id=02b8dabc&scoped=true"
import script from "./GalleryDetailLink.vue?vue&type=script&lang=js"
export * from "./GalleryDetailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8dabc",
  null
  
)

export default component.exports